import { createContext, ReactNode, useContext, useState } from 'react';

type MobileNavContextValue = {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
};

const MobileNavContext = createContext<MobileNavContextValue | null>(null);

export function MobileNavProvider({ children }: { children: ReactNode }) {
    const [isOpen, setIsOpen] = useState(false);
    return <MobileNavContext.Provider value={{ isOpen, setIsOpen }}>{children}</MobileNavContext.Provider>;
}

export function useMobileNav(): MobileNavContextValue {
    const value = useContext(MobileNavContext);
    if (!value) throw new Error('useMobileNav must be used within a MobileNavProvider');
    return value;
}
